module.exports = __webpack_public_path__ + "img/gynaecology.4a8e99eb.svg";